var window_width = jQ(window).width();

import('./modules/filters').then(module => {});


jQ(document).ready(function () {
    jQ('body').on('click', '.open-map-view', function () {
        jQ('.switch #map').prop('checked', true).change();
    });

    jQ(window).scroll(function () {
        stickyHead();
    });

    jQ(window).resize(function () {
        window_width = jQ(window).width();

        stickyHead();

        import('./modules/map/resizePage').then(module => {
            module.default();
        });
    });

    import('./modules/slider').then(module => {
        window.CategoryPageSlider = new module.default({
            slider: ".wrap_custom_page_big_slider",
            wrap_big_image: ".custom_page_big_image",
            use_preview: false,
            resize_width: true,
            stop_defaut_event: false,
            big_image_show_next_slide_on_click: false,
            image_index: ".current_photo"
        });
        window.CategoryPageSlider.SliderInit();
    });
});


function stickyHead() {
    var scroll = jQ(window).scrollTop();

    if (window_width <= 600 && scroll > 0) {
        jQ('#header').css('cssText', "position: fixed !important;");
        jQ('#header_filters').css({
            'position': 'fixed',
            'top': jQ("#header").outerHeight(),
        });
        jQ(".category_view .view_map_page.list_page #internal_content").css("margin-top", '130px');
        jQ(".category_view .view_map_page.list_page #internal_content.company_view").css("margin-top", '60px');
    } else {
        jQ('#header').css({
            'position': 'relative',
        });
        jQ('#header_filters').css({
            'position': 'relative',
            'top': '0',
        });
        jQ(".category_view .view_map_page.list_page #internal_content").css("margin-top", '0');
        jQ(".category_view .view_map_page.list_page #internal_content.company_view").css("margin-top", '0');
    }
}

function matchingWidgetClick(e) {
    import('./actions/matchingWidgetClick').then(module => {
        module.default(e);
    });
}

function setFilterLocation(elem, e)
{
    var form = jQ('form[name="housing_filter"]',  window.parent.document);
    jQ('input[name="custom_geo"]', form).val('');
    jQ('input[name="location"]', form).val(jQ(elem).text());
    jQ('input[name="location_id"]', form).val(jQ(elem).attr('default-id'));
    jQ('input[name="location_type"]', form).val(jQ(elem).attr('default-type'));
    jQ('input[name="location_url"]', form).val(jQ(elem).attr('href').replace("/apartments/", "").replace("/sublets/", ""));

    if(jQ('input[name="category[]"]:checked', form).is(':checked')){
        jQ('input[name="category[]"]:checked', form).prop('checked', false);
        if(jQ(elem).attr('default-cat')){
            jQ('input[name="category[]"][value='+jQ(elem).attr('default-cat')+']', form).prop('checked', true);
        }
    }

    import('./modules/filters/startProcessSearchAds').then(module => {
        module.default(false);
    });

    e.preventDefault();
}
window.setFilterLocation = setFilterLocation;
